import { Content, Icon, ListCell, ListView } from '@modulor/react';
import React from 'react';

interface LoadedFileCellProps {
  uploadedFile: File | undefined;
  handleResetFile: () => void;
  isDisabled?: boolean;
  id?: string;
}

const LoadedFileCell: React.FC<LoadedFileCellProps> = ({ id, uploadedFile, handleResetFile, isDisabled }) => (
  <ListView>
    <ListCell
      className="list-cell-control"
      id={id}
      text={uploadedFile?.name}
      content={
        (
          <Content>
            <Icon
              style={{
                color: 'var(--icon-main)',
              }}
              onClick={handleResetFile}
              disabled={isDisabled}
              name="delete_outlined"
            />
          </Content>
        ) as unknown as string
      }
    />
  </ListView>
);

export default LoadedFileCell;
